import logoSrc from "@/assets/icons/logo.png";

const CircularLogo = ({
  size = 80,
  animated = true,
}: {
  size?: number;
  animated?: boolean;
}) => {
  return (
    <div
      className="inline-flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <img
        src={logoSrc}
        alt="AutopilotQA"
        width={size}
        height={size}
        className={`rounded-full ${animated ? "animate-spin-slow" : ""}`}
      />
    </div>
  );
};

export default CircularLogo;
